import type { Checkpoint, GarageType } from "@App/types";
import type { SupportedCountry } from "@App/utils/country";
import React from "react";
import { useTranslation } from "react-i18next";

type CheckpointDetailsProps = {
  checkpoint: Checkpoint;
  garageType?: GarageType;
  hideDescription?: boolean;
  countryCode?: SupportedCountry;
};

export const CheckpointDetails = React.memo<CheckpointDetailsProps>(
  ({ checkpoint, garageType, hideDescription, countryCode = "DE" }: CheckpointDetailsProps) => {
    const { t } = useTranslation();

    return (
      <div className={"mb-6"}>
        {checkpoint.logo && (
          <img className="mb-3 h-5" src={`/storage/${checkpoint.logo}`} alt={checkpoint.name} />
        )}
        <div className="text-lg font-bold slab-font mb-1">
          Die Prüfung erfolgt durch: {checkpoint.name}
        </div>
        {!hideDescription && garageType && garageType.name === "Prüfstelle" && (
          <p>{t("checkpointDetails.regulated-info", { context: countryCode })}</p>
        )}
        {!hideDescription && (!garageType || (garageType && garageType.name !== "Prüfstelle")) && (
          <p>
            Ein neutraler, staatlich anerkannter Prüfer kommt direkt zur Werkstatt und prüft dein
            Fahrzeug. Falls du zusätzlich einen Vorabcheck wünschst, um prüfen zu lassen, ob dein
            Auto "durch die Prüfung kommt", kannst du das im nächsten Buchungsschritt vermerkern.
          </p>
        )}
      </div>
    );
  },
);
